var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.attachmentData.field_page_image)?_c('div',[_c('img',{staticClass:"image-banner",attrs:{"src":_vm.endpoint + this.attachmentData.field_page_image.attributes.uri.url,"alt":""}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }